import { assert } from '../../lib/assert-sidecar'
import { common } from '../../main/common-sidecar'
import { voyageColors } from './voyageColors-sidecar'
import type { IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageParticles } from './voyageParticles-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'
import { voyageWebsockets } from './voyageWebsockets-sidecar'

export function crewUpdate(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.crewState
  assert.notNil(d)

  d.useSystemTimer += ds

  let useSystemTime = 0.5
  if (d.useSystemTimer > useSystemTime) {
    d.useSystemTimer -= useSystemTime
    let tHere = voyageTilemap.getSafeIJ(obj)
    if (tHere) {
      let sys = tHere.system
      if (sys) {
        let toHeal = obj
        if (toHeal && !toHeal.isDying) {
          let healRate = 20
          let healAmount = healRate * useSystemTime

          if (toHeal.energy < voyageCrew.maxEnergy) {
            let p = voyageParticles.create('zzz', obj.x, obj.y)
            p.image.tint = voyageColors.green

            if (voyageWebsockets.getIsHost()) {
              voyageCrew.hurtEnergy(toHeal, -healAmount)
            }
          }
        }
      }
    }
  }
}
